/* eslint-disable @typescript-eslint/no-explicit-any */

import { TOUCH_DELAY, LEAVE_TOUCH_DELAY } from '../../../../internal/constants';
export function useTooltipControllerTouch(dependencies) {
  const {
    state,
    handleEnter,
    handleClose
  } = dependencies;
  const {
    timers
  } = state;
  const {
    children
  } = dependencies.props;
  const handleTouchStart = event => {
    state.ignoreNonTouchEvents = true;
    const childrenProps = children.props;
    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
    window.clearTimeout(timers.leave);
    window.clearTimeout(timers.touch);
    event.persist();
    timers.touch = window.setTimeout(() => {
      handleEnter(event);
    }, TOUCH_DELAY);
  };
  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    window.clearTimeout(timers.touch);
    window.clearTimeout(timers.leave);
    event.persist();
    timers.leave = window.setTimeout(() => {
      handleClose();
    }, LEAVE_TOUCH_DELAY);
  };
  return {
    handleTouchStart,
    handleTouchEnd
  };
}